// What counts as "unknown" for the Hide unknown switch, and the percentage base once it is applied. Pure, so it can be tested without the visualization.
export const NO_CATEGORY_DATA = "(No data for this category)";

/**
 * "Unknown" = no value ("(No data...)"), the literal Unknown/UNKNOWN some fields carry, and - for search engines and social networks only - "Other" (not one of the known
 * ones). "Other" is a real bucket in other filters (it can be the biggest browser group), so it is only unknown here.
 */
export const isUnknownBucketName = (name: unknown, menuType?: string): boolean =>
  typeof name === "string" && (name === NO_CATEGORY_DATA || /^unknown$/i.test(name) || ((menuType === "search_engine" || menuType === "social_network") && /^other$/i.test(name)));

export interface DockItem {
  menuName?: string;
  user?: number;
  historical?: boolean;
}

/** The base of a bubble's percentage: the sum of the dock's groups, leaving the unknown ones out when asked. */
export const knownTotal = (items: DockItem[], hideUnknown: boolean, menuType?: string): number =>
  items.reduce(
    (sum, item) => (item?.historical === true && !(hideUnknown && isUnknownBucketName(item.menuName, menuType)) ? sum + (Number(item.user) || 0) : sum),
    0
  );
